export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
vm(require("SharedI18nStrings/lang/countryCodes/en.lyaml"));
vm(require("SharedI18nStrings/lang/languageNames/en.lyaml"));
vm(require("./audio-preview/en.lyaml"));
vm(require("./edit-custom-message/en.lyaml"));
vm(require("./manage-custom-message-list/en.lyaml"));
vm(require("./recording-consent-message/en.lyaml"));
at({ "en": { "calling-custom-messages-library": { "key": "value", "edit-messages-cta": { "label": "Edit audio messages", "tooltip": "Create, edit, or upload audio messages to use in calling features, like voicemail and IVR." } } } });
};